const jumpPage = [{
    path: "/jumpPage",
    component: () => import("@/views/jumpPage/index.vue"),
    name: "跳转页",
    meta: {
        title: "跳转页"
    },
}];

export default jumpPage;